import BaselineTotalDemandActions from "../actions/baselineTotalDemandActions";

const BaselineTotalDemandReducer = (state = { isBaselineTotalDemandLoading: false, isBaselineTotalDemandTimelineLoading: false }, action) => {
    switch (action.type) {
        case BaselineTotalDemandActions.BASELINE_TOTAL_DEMAND_REQUEST:
            return {
                ...state,
                isBaselineTotalDemandLoading: true
            };
        case BaselineTotalDemandActions.BASELINE_TOTAL_DEMAND_SUCCESSFUL:
            return {
                ...state,
                isBaselineTotalDemandLoading: false,
                baselineTotalDemand: action.data
            };
        case BaselineTotalDemandActions.BASELINE_TOTAL_DEMAND_FAILED:
            return {
                ...state,
                errorBaselineTotalDemand: {},
                isBaselineTotalDemandLoading: false,
                baselineTotalDemand: null
            };


        // ************ BASELINE TOTAL DEMAND TIME LINE **********
        case BaselineTotalDemandActions.BASELINE_TOTAL_DEMAND_TIME_LINE_REQUEST:
            return {
                ...state,
                isBaselineTotalDemandTimelineLoading: true,
                baselineTotalDemandTimeline: null
            };
        case BaselineTotalDemandActions.BASELINE_TOTAL_DEMAND_TIME_LINE_SUCCESSFUL:
            return {
                ...state,
                isBaselineTotalDemandTimelineLoading: false,
                baselineTotalDemandTimeline: action.data
            };
        case BaselineTotalDemandActions.BASELINE_TOTAL_DEMAND_TIME_LINE_FAILED:
            return {
                ...state,
                errorBaselineTotalDemandTimeline: {},
                isBaselineTotalDemandTimelineLoading: false,
                baselineTotalDemandTimeline: null
            };

        default:
            return {
                ...state
            };
        //   break;
    }
};

export default BaselineTotalDemandReducer;
